
import { Component, Prop, Vue } from 'vue-property-decorator';
import LoyaltySubscriptionTypeAddForm from '@/form/loyalty/loyaltySubscriptionType/LoyaltySubscriptionTypeAddForm';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
@Component({
    components: { FormGroup }
})
export default class LoyaltySubscriptionTypeAddComponent extends Vue {
    @Prop() readonly form!: LoyaltySubscriptionTypeAddForm;
}
